module.exports = __webpack_public_path__ + "img/desktop computer.9840afe7.svg";